import {
  PAYMENT_RESULT_FEATURE_KEY,
  paymentResultReducer,
} from '@cashier/cashier-data-access';
import { createFeature } from '@cashier/cashier-shared';

import { paymentResultMiddleware } from './lib/middlewares';
import { PaymentResult as PaymentResultV1 } from './lib/v1';
import { PaymentResult as PaymentResultV2 } from './lib/v2';

export const PaymentResultFeature = createFeature({
  component: {
    PaymentResultV1,
    PaymentResultV2,
  },

  hook: {},

  store: {
    epics: [],

    middlewares: [paymentResultMiddleware],

    reducerMap: {
      [PAYMENT_RESULT_FEATURE_KEY]: paymentResultReducer,
    },
  },
});
